import moment from 'moment'

export const getPrice = (
  price: number,
  discount: number,
  iva: string,
  withDiscount: boolean = true,
  endDiscountDate?: string | undefined,
) => {
  let finalPrice: number = 0
  if (!price) return 0
  let priceWithIva = parseFloat(price.toString())
  if (iva) {
    priceWithIva = priceWithIva + ((priceWithIva * parseInt(iva)) / 100)
  }

  if (withDiscount === true && moment().isSameOrBefore(moment(endDiscountDate).endOf('day'))) {
    if (discount) {
      finalPrice = Math.round(priceWithIva * (1 - (discount / 100)))
    } else {
      finalPrice = priceWithIva
    }
  } else {
    finalPrice += priceWithIva
  }
  return finalPrice;
}

export const formatPrice = (price: number) => {
  return `COP${price.toLocaleString('es-CO', { style: 'currency', currency: 'COP' }).replace(',00', '')}`
}